import React, { useState } from 'react';
import styles from './CustodianCard.module.scss';
import { Topography } from '../Topography/Topography';
import { Icon } from '../Icon/Icon';
import { useDispatch } from 'react-redux';
import { Spinner } from 'reactstrap'
import { addToFavourite, deleteCustodian } from 'store/actions/favouriteCustodians.action';
import { Radio } from '..';

export type CustodianCardProps = {
  id: number;
  name: string;
  address: string;
  state: string;
  zipcode: string;
  city: string;
  isChecked: boolean;
  onClick: (selectedLocation: string | null, selectedSiteLocationName: string | null) => void;
  favorite: boolean;
  isDetailsLoading: boolean;
  isFormRequest: boolean;
  location_name: string[]
  location_address: [string[]]
  specialty: string[]
  enterprise: string
  alias: string
  selectedLocation?: string | null
};

export const CustodianCard: React.FC<CustodianCardProps> = ({
  id,
  name,
  address,
  city,
  state,
  zipcode,
  location_name,
  location_address,
  specialty,
  enterprise,
  alias,
  isChecked,
  onClick,
  favorite,
  isDetailsLoading,
  isFormRequest,
  selectedLocation
}) => {
  const dispatch = useDispatch();
  const [isFavourite, setIsFavourite] = useState<boolean>(favorite);
  const iconName = isFavourite ? 'star' : 'star-empty';
  const descripton = `${address}, ${city}, ${state} ${zipcode}`;

  const handleAddToFavourite = () => {
    setIsFavourite(!isFavourite);
    if (isFavourite) dispatch(deleteCustodian(id))
    else dispatch(addToFavourite(id, isFormRequest));
  };

  return (<>
    {location_name?.length == 0 && (<div className={styles['root']+' custodian_itms'}>
      <div className='ml-3'>
        <div className='justify-self-start'>
          <div className={`d-flex align-items-center`}>
            <Topography.H4>{name}</Topography.H4>
            {enterprise && <div className='ml-2'>&bull; {enterprise}</div>}
            {alias && <div className='ml-2'>&bull; <span className={styles.alias}>{alias}</span></div>}
          </div>
          <p>{descripton}</p>
          {specialty.length > 0 && (<div className='mt-2 custom_txt_wrap'><b>Specialty</b>:- {specialty?.join(', ')}</div>)}
        </div>
      </div>
      <div className='align-self-start ms-auto mt-3 fav_icons'>
        <Icon className={styles.icon} name={iconName} onClick={handleAddToFavourite} />
      </div>
      <div className='align-self-start justify-self-end ml-3 mt-3'>
        <Radio name='' value='' checked={isChecked && !selectedLocation} onClick={() => onClick(null, null)} />
      </div>
    </div>)}
    {location_name.map((location, i) => (<>
      <div className={styles['root']+ ' custodian_itms'}>
        <div className='ml-3'>
          <div className='justify-self-start' key={i}>
            <div className={`d-flex align-items-center`}>
              <Topography.H4 className='cus_name_heading'>{location}</Topography.H4>
              {enterprise && <div className='ml-2'>&bull; {enterprise}</div>}
              {alias && <div className='ml-2'>&bull; <span className={styles.alias}>{alias}</span></div>}
            </div>
            <p>{location_address[i]?.join(' ')}</p>
            {specialty.length > 0 && (<div className='mt-2 custom_txt_wrap'><b>Specialty</b>:- {specialty?.join(', ')}</div>)}
          </div>
        </div>
        <div className='align-self-start ml-auto mt-3 fav_icons'>
          <Icon className={styles.icon} name={iconName} onClick={handleAddToFavourite} />
        </div>
        <div className='align-self-start justify-self-end ml-3 mt-3'>
          <button className='btn_custodian' name='' value=''  onClick={() => onClick(location_address[i].join(' '), location !== name ? location : null)}> Select Provider </button>
        </div>

      </div>
    </>))}
  </>);
};
